module.exports = __webpack_public_path__ + "static/flip-checkbox-9b05a5d208a103cba31abcab2b08784d.gif";